/**
 * Module dependencies.
 */

import { ListFilters } from 'app/components/organisms/crud/form-filters/form-filters-type';
import { CrudListType, CrudTemplate, ListColumns } from 'app/components/organisms/crud/form-types';
import { normalizeTemplate } from 'app/components/organisms/crud/utils';
import { appRoutes } from 'app/routes';
import { TFunction } from 'i18next';
import { DeviceAlarm } from 'app/types/medication';
import React from 'react';
import { DateTime } from 'app/components/atoms/date-time/date-time';

/**
 * List labels.
 */

const listColumns = (translate: TFunction): ListColumns<DeviceAlarm> => [
  {
    title: translate('common.table.columns.deviceId'),
    dataIndex: 'deviceId',
    key: 'deviceId',
    render: (item: DeviceAlarm) => item.deviceId
  },
  {
    title: translate('common.table.columns.scheduleAlarmId'),
    dataIndex: 'scheduleAlarmId',
    key: 'scheduleAlarmId',
    render: (item: DeviceAlarm) => item.scheduleAlarmId
  },
  {
    title: translate('common.table.columns.snoozeFireDate'),
    dataIndex: 'snoozeFireDate',
    key: 'snoozeFireDate',
    render: (item: DeviceAlarm) => <DateTime date={item.snoozeFireDate} />
  },
  {
    title: translate('common.table.columns.snooze'),
    dataIndex: 'snooze',
    key: 'snooze',
    render: (item: DeviceAlarm) => (item.snooze ? item.snooze : 'N/A')
  },
  {
    title: translate('common.table.columns.createdAt'),
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (item: DeviceAlarm) => <DateTime date={item.createdAt} />
  },
  {
    title: translate('common.table.columns.updatedAt'),
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    render: (item: DeviceAlarm) => <DateTime date={item.updatedAt} />
  }
];

/**
 * List filters.
 */

const listFilters = (translate: TFunction): ListFilters => [
  {
    type: 'inputSearch',
    inline: true,
    name: 'search',
    label: String(translate('common.labels.search'))
  }
];

/**
 * List.
 */

const list = (translate: TFunction): CrudListType<DeviceAlarm> => ({
  addButton: undefined,
  columns: listColumns(translate),
  canEdit: false,
  canRemove: false,
  style: { minWidth: 500, maxWidth: '100%' },
  nestedList: item => {
    return item.deviceAlarms;
  },
  route: appRoutes.dashboard.users.detail.medications,
  key: ['medicationsDeviceAlarms'],
  endpoint: null,
  filters: listFilters(translate)
});

/**
 * Config.
 */

export function createExtendedDeviceAlarmsTemplate(translate: TFunction): CrudTemplate<DeviceAlarm> {
  return normalizeTemplate(translate, {
    list: list(translate)
  });
}
